"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useDynamicCallback_1 = __importDefault(require("../hooks/useDynamicCallback"));
var Context_1 = __importDefault(require("./Context"));
exports.SquarePaymentForm = function (_a) {
    var _b = _a.apiWrapper, apiWrapper = _b === void 0 ? 'reactjs/0.7.3' : _b, _c = _a.formId, formId = _c === void 0 ? 'sq-payment-form' : _c, _d = _a.inputStyles, inputStyles = _d === void 0 ? [
        {
            _mozOsxFontSmoothing: 'grayscale',
            _webkitFontSmoothing: 'antialiased',
            backgroundColor: 'transparent',
            color: '#373F4A',
            fontFamily: 'Helvetica Neue',
            fontSize: '16px',
            lineHeight: '24px',
            padding: '16px',
            placeholderColor: '#CCC',
        },
    ] : _d, _e = _a.sandbox, sandbox = _e === void 0 ? false : _e, props = __rest(_a, ["apiWrapper", "formId", "inputStyles", "sandbox"]);
    var _f = react_1.useState('loading'), applePayState = _f[0], setApplePayState = _f[1];
    var _g = react_1.useState('loading'), googlePayState = _g[0], setGooglePayState = _g[1];
    var _h = react_1.useState('loading'), masterpassState = _h[0], setMasterpassState = _h[1];
    var _j = react_1.useState(''), errorMessage = _j[0], setErrorMessage = _j[1];
    var _k = react_1.useState(false), scriptLoaded = _k[0], setScriptLoaded = _k[1];
    var _l = react_1.useState(undefined), paymentForm = _l[0], setPaymentForm = _l[1];
    var _m = react_1.useState(false), formLoaded = _m[0], setFormLoaded = _m[1];
    function cardNonceResponseReceived(errors, nonce, cardData, billingContact, shippingContact, shippingOption) {
        if (errors || !props.createVerificationDetails) {
            props.cardNonceResponseReceived(errors, nonce, cardData, '', billingContact, shippingContact, shippingOption);
            return;
        }
        paymentForm &&
            paymentForm.verifyBuyer(nonce, props.createVerificationDetails(), function (err, result) {
                props.cardNonceResponseReceived(err ? [err] : null, nonce, cardData, result ? result.token : undefined, billingContact, shippingContact, shippingOption);
            });
    }
    var cardNonceResponseReceivedCallback = useDynamicCallback_1.default(cardNonceResponseReceived);
    function createNonce() {
        paymentForm && paymentForm.requestCardNonce();
    }
    function verifyBuyer(source, verificationDetails, callback) {
        paymentForm && paymentForm.verifyBuyer(source, verificationDetails, callback);
    }
    function methodsSupported(methods) {
        var keys = Object.keys(methods);
        if (keys.includes('masterpass')) {
            setMasterpassState(methods.masterpass === true ? 'ready' : 'unavailable');
        }
        if (keys.includes('applePay')) {
            setApplePayState(methods.applePay === true ? 'ready' : 'unavailable');
        }
        if (keys.includes('googlePay')) {
            setGooglePayState(methods.googlePay === true ? 'ready' : 'unavailable');
        }
        props.methodsSupported && props.methodsSupported(methods);
    }
    var paymentFormLoaded = function () {
        setFormLoaded(true);
        props.paymentFormLoaded && props.paymentFormLoaded();
    };
    function loadSqPaymentFormLibrary(onSuccess, onError) {
        if (document.getElementById('sq-payment-form-script') && typeof SqPaymentForm === 'function') {
            onSuccess && onSuccess();
            return;
        }
        var script = document.createElement('script');
        script.id = 'sq-payment-form-script';
        if (sandbox) {
            script.src = 'https://js.squareupsandbox.com/v2/paymentform';
        }
        else {
            script.src = 'https://js.squareup.com/v2/paymentform';
        }
        script.onload = function () {
            onSuccess && onSuccess();
        };
        script.onerror = function () {
            onError && onError();
        };
        document.body.appendChild(script);
    }
    function buildSqPaymentFormConfiguration(props) {
        var config = {
            apiWrapper: apiWrapper,
            applicationId: props.applicationId,
            autoBuild: false,
            callbacks: {
                cardNonceResponseReceived: props.cardNonceResponseReceived ? cardNonceResponseReceivedCallback : null,
                createPaymentRequest: props.createPaymentRequest,
                inputEventReceived: props.inputEventReceived,
                methodsSupported: methodsSupported,
                paymentFormLoaded: paymentFormLoaded,
                shippingContactChanged: props.shippingContactChanged,
                shippingOptionChanged: props.shippingOptionChanged,
                unsupportedBrowserDetected: props.unsupportedBrowserDetected,
            },
            locationId: props.locationId,
        };
        if (document.getElementById(props.formId + "-sq-card")) {
            config.card = {
                elementId: formId + "-sq-card",
                inputStyle: inputStyles && inputStyles[0],
            };
        }
        else if (document.getElementById(formId + "-sq-gift-card")) {
            config.giftCard = {
                elementId: formId + "-sq-gift-card",
                placeholder: props.placeholderGiftCard || '• • • •  • • • •  • • • •  • • • •',
            };
            config.inputClass = props.inputClass || 'sq-input';
            config.inputStyles = inputStyles;
        }
        else {
            config.inputClass = props.inputClass || 'sq-input';
            config.inputStyles = inputStyles;
            if (document.getElementById(formId + "-sq-apple-pay")) {
                config.applePay = { elementId: formId + "-sq-apple-pay" };
            }
            if (document.getElementById(formId + "-sq-google-pay")) {
                config.googlePay = { elementId: formId + "-sq-google-pay" };
            }
            if (document.getElementById(formId + "-sq-masterpass")) {
                config.masterpass = { elementId: formId + "-sq-masterpass" };
            }
            if (document.getElementById(formId + "-sq-card-number")) {
                config.cardNumber = {
                    elementId: formId + "-sq-card-number",
                    placeholder: props.placeholderCreditCard || '• • • •  • • • •  • • • •  • • • •',
                };
            }
            if (document.getElementById(formId + "-sq-cvv")) {
                config.cvv = { elementId: formId + "-sq-cvv", placeholder: props.placeholderCVV || 'CVV ' };
            }
            if (document.getElementById(formId + "-sq-postal-code")) {
                config.postalCode = {
                    elementId: formId + "-sq-postal-code",
                    placeholder: props.placeholderPostal || '12345',
                };
            }
            else {
                config.postalCode = false;
            }
            if (document.getElementById(formId + "-sq-expiration-date")) {
                config.expirationDate = {
                    elementId: formId + "-sq-expiration-date",
                    placeholder: props.placeholderExpiration || 'MM/YY',
                };
            }
        }
        return config;
    }
    function renderSqPaymentForm() {
        if (!scriptLoaded || paymentForm || errorMessage.length > 0) {
            return;
        }
        try {
            var newPaymentForm = new SqPaymentForm(buildSqPaymentFormConfiguration(props));
            newPaymentForm.build();
            setPaymentForm(newPaymentForm);
        }
        catch (error) {
            var errorMessage_1 = error.message || 'Unable to build Square payment form';
            setErrorMessage(errorMessage_1);
        }
    }
    react_1.useEffect(function () {
        if (!formLoaded || !paymentForm) {
            return;
        }
        paymentForm.recalculateSize();
        props.postalCode && paymentForm.setPostalCode(props.postalCode());
        props.focusField && paymentForm.focus(props.focusField());
    }, [formLoaded, paymentForm]);
    react_1.useEffect(function () {
        loadSqPaymentFormLibrary(function () { return setScriptLoaded(true); }, function () { return setErrorMessage('Unable to load Square payment library'); });
    }, []);
    react_1.useEffect(function () {
        renderSqPaymentForm();
        return function () {
            if (paymentForm) {
                paymentForm.destroy();
                setPaymentForm(undefined);
            }
        };
    }, [scriptLoaded]);
    react_1.useEffect(function () {
        if (!paymentForm || masterpassState !== 'ready') {
            return;
        }
        var srcBtn = document.getElementById(formId + "-sq-masterpass");
        if (!srcBtn) {
            return;
        }
        var imageUrl = paymentForm.masterpassImageUrl();
        srcBtn.style.display = 'inline-block';
        srcBtn.style.backgroundImage = "url(" + imageUrl + ")";
    }, [paymentForm, masterpassState]);
    if (errorMessage) {
        return (react_1.default.createElement("div", { className: "sq-payment-form" },
            react_1.default.createElement("div", { className: "sq-error-message" }, errorMessage)));
    }
    var context = {
        applePayState: applePayState,
        formId: formId,
        googlePayState: googlePayState,
        masterpassState: masterpassState,
        onCreateNonce: createNonce,
        onVerifyBuyer: verifyBuyer,
    };
    return (react_1.default.createElement(Context_1.default.Provider, { value: context },
        react_1.default.createElement("div", { id: formId, className: "sq-payment-form" }, props.children)));
};
//# sourceMappingURL=SquarePaymentForm.js.map